<mat-card class="cardWithShadow theme-card" style="margin-bottom: 10px;margin-top: -20px;">
    <mat-card-header>
      <button mat-flat-button color="primary" (click)="volver()">
        <i-tabler class="custom-icon" name="arrow-left"></i-tabler>
        <span class="button-text">Volver</span>
      </button>
    </mat-card-header>
  </mat-card>


<mat-card class="cardWithShadow theme-card">
    <mat-card-content class="b-t-1">
        <div class="row">
            <div class="col-md-12">
                <div class="row">

            
                    <mat-tab-group style="    width: 100%;">
                        <mat-tab label="Perfiles"> 


                            <div class="container">
                       
                                <div class="header mt-3">
                                    <div></div>
                                    <button mat-raised-button color="primary" (click)="agregarPerfil()">Agregar Perfil</button>
                                </div>
                            
                          </div>
                        
                            <table mat-table [dataSource]="perfiles" matSort>
                      
                           
                                <!-- Columna Nombre -->
                                <ng-container matColumnDef="nombre">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                                  <td mat-cell *matCellDef="let perfil">{{ perfil.nombre }}</td>
                                </ng-container>
                          
                          
                          
                                <!-- Columna Acciones -->
                                <ng-container matColumnDef="acciones">
                                  <th mat-header-cell class="acciones-header" *matHeaderCellDef>Acciones</th>
                                  <td mat-cell class="acciones-cell" *matCellDef="let perfil">
                                    <button mat-icon-button color="primary" (click)="editarPerfil(perfil)">
                                      <mat-icon>edit</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn" (click)="eliminarPerfil(perfil.id)">
                                      <mat-icon>delete</mat-icon>
                                    </button>
                                  </td>
                                </ng-container>
                          
                                <tr mat-header-row *matHeaderRowDef="displayedColumnsPerfiles"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsPerfiles;"></tr>
                              </table>
                          
                        
                        </mat-tab>
                        <mat-tab label="Tarjetas"> 
                            
                            <div class="container">
                       
                                <div class="header">
                                  <mat-form-field appearance="outline">
                                    <mat-label>Buscar Tarjeta</mat-label>
                                    <input matInput [(ngModel)]="palabraClave" (keyup)="callData()" placeholder="Escribe aquí..." />
                                  </mat-form-field>
                                  <button mat-raised-button color="primary" (click)="agregarTarjeta()">Agregar Tarjeta</button>
                                </div>
                            
                          </div>
                                <table mat-table [dataSource]="tarjetas" matSort>
                            
                                 
                                  <!-- Columna Nombre -->
                                  <ng-container matColumnDef="nombre">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                                    <td mat-cell *matCellDef="let tarjeta">{{ tarjeta.nombre }}</td>
                                  </ng-container>
                            
                            
                            
                                  <!-- Columna Acciones -->
                                  <ng-container matColumnDef="acciones">
                                    <th mat-header-cell class="acciones-header" *matHeaderCellDef>Acciones</th>
                                    <td mat-cell class="acciones-cell" *matCellDef="let tarjeta">
                                      <button mat-icon-button color="primary" (click)="editarTarjeta(tarjeta)">
                                        <mat-icon>edit</mat-icon>
                                      </button>
                                      <button mat-icon-button color="warn" (click)="eliminarTarjeta(tarjeta.id)">
                                        <mat-icon>delete</mat-icon>
                                      </button>
                                    </td>
                                  </ng-container>
                            
                                  <tr mat-header-row *matHeaderRowDef="displayedColumnsTarjetas"></tr>
                                  <tr mat-row *matRowDef="let row; columns: displayedColumnsTarjetas;"></tr>
                                </table>
                            
                                <!-- Paginador -->
                                <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="12" [pageSizeOptions]="[12, 24, 50]" (page)="getServerData($event)">
                                </mat-paginator> 

                        </mat-tab>
                        <mat-tab label="Ficha Motor"> 
                            <div class="container">
                                <div class="header">
                                  <mat-form-field appearance="outline">
                                    <mat-label>Buscar Ficha Motor</mat-label>
                                    <input matInput [(ngModel)]="palabraClaveFichaMotor" (keyup)="callFichaMotorData()" placeholder="Escribe aquí..." />
                                  </mat-form-field>
                                  <button mat-raised-button color="primary" (click)="agregarFichaMotor()">Agregar Ficha Motor</button>
                                </div>
                            </div>
                            <table mat-table [dataSource]="fichaMotorTarjetas" matSort>
                              <ng-container matColumnDef="patente">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Patente</th>
                                <td mat-cell *matCellDef="let tarjeta">{{ tarjeta.vehiculo?.patente || tarjeta.fichaMotor?.vehiculo?.patente || tarjeta.fichaMotor?.patente || tarjeta.patente || '-' }}</td>
                              </ng-container>

                              <ng-container matColumnDef="nombre">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                                <td mat-cell *matCellDef="let tarjeta">{{ tarjeta.nombre }}</td>
                              </ng-container>

                              <ng-container matColumnDef="correo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Correo</th>
                                <td mat-cell *matCellDef="let tarjeta">{{ tarjeta.correo }}</td>
                              </ng-container>

                              <ng-container matColumnDef="fechaCreacion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha creación</th>
                                <td mat-cell *matCellDef="let tarjeta">{{ tarjeta.insertDate | date: 'dd/MM/yyyy' }}</td>
                              </ng-container>

                              <ng-container matColumnDef="acciones">
                                <th mat-header-cell class="acciones-header" *matHeaderCellDef>Acciones</th>
                                <td mat-cell class="acciones-cell" *matCellDef="let tarjeta">
                                  <button mat-icon-button color="primary" (click)="editarFichaMotor(tarjeta)">
                                    <mat-icon>edit</mat-icon>
                                  </button>
                                  <button mat-icon-button color="warn" (click)="eliminarTarjeta(tarjeta.id)">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </td>
                              </ng-container>

                              <tr mat-header-row *matHeaderRowDef="displayedColumnsFichaMotor"></tr>
                              <tr mat-row *matRowDef="let row; columns: displayedColumnsFichaMotor;"></tr>
                            </table>

                            <mat-paginator [length]="fichaMotorLength" [pageIndex]="fichaMotorPageIndex" [pageSize]="12" [pageSizeOptions]="[12, 24, 50]" (page)="getFichaMotorServerData($event)">
                            </mat-paginator>
                        </mat-tab>
                    </mat-tab-group>
                    

                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
